import React, { useMemo } from 'react'

import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { BLOCKS, INLINES } from '@contentful/rich-text-types'

import ContentfulHyperlink from './components/ContentfulHyperlink'
import Paragraph from './components/Paragraph'
import StructuredData from './components/StructuredData'

const baseEmbeddeds = { StructuredData }
const getDefaultNodes = (links, embeddeds) => ({
  [BLOCKS.PARAGRAPH]: (_, children) => <Paragraph>{children}</Paragraph>,
  [INLINES.HYPERLINK]: node => {
    const { content } = node
    if (content.length) {
      const [{ value }] = content
      const { uri } = node.data
      const isGetApp = uri.includes('getapp.')

      return (
        <ContentfulHyperlink
          href={uri}
          target={isGetApp ? '' : '_blank'}
          rel={isGetApp ? undefined : 'nofollow noopener'}
        >
          {value}
        </ContentfulHyperlink>
      )
    }
    return null
  },
  [INLINES.ASSET_HYPERLINK]: (node, children) => {
    const href = node.data?.target?.fields?.file?.url

    return href ? (
      <a href={href} download className="Contentful-asset-link">
        {children}
      </a>
    ) : null
  },
  [BLOCKS.EMBEDDED_ENTRY]: node => {
    const { data } = node
    // You can find the possible types in https://app.contentful.com/spaces/1nw0m35kh5t7/content_types/
    const { __typename: type, content, ...embed } = links[data.target?.sys?.id] || {}

    if (embeddeds[type]) {
      const Element = embeddeds[type]
      return (
        <Element className={`Contentful-${type}`} {...embed}>
          {content?.json && <Contentful document={content.json} links={links} />}
        </Element>
      )
    }
    return <div className="Contentful-embed">Embed {type}</div>
  },
})

const getOptions = ({ links, embeddeds, renderText, getCustomNodes }) => {
  return {
    ...(renderText ? { renderText } : {}),
    renderNode: {
      ...getDefaultNodes(links, embeddeds),
      ...getCustomNodes(links),
    },
  }
}

const Contentful = ({ document, links = {}, customEmbeddeds, renderText, getCustomNodes = () => {} }) => {
  const options = useMemo(() => {
    const embeddeds = { ...baseEmbeddeds, ...customEmbeddeds }
    return getOptions({ links, embeddeds, renderText, getCustomNodes })
  }, [links, customEmbeddeds, renderText, getCustomNodes])
  return documentToReactComponents(document, options)
}

export default Contentful
